import { render, staticRenderFns } from "./PaxosExchangeInput.vue?vue&type=template&id=7968ca23&"
import script from "./PaxosExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./PaxosExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports